/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  INVITE_USER_SUCCESS,
  INVITE_USER_FAILURE,
} from "../actions/actionTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case INVITE_USER_SUCCESS:
      return {
        inviteSuccess: true,
      };
    case INVITE_USER_FAILURE:
      return {
        inviteSuccess: false,
        message: action.err.message,
      };
    default:
      return state;
  }
}
